import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DataTableComponent from "../../common/DataTable/PrimeDataTable";
import ActivateDeactivateModal from '../../common/ActivateDeactivateModal';
import Grid from 'apollo-react/components/Grid';
import Paper from 'apollo-react/components/Paper';
import Typography from 'apollo-react/components/Typography';

const CategoryUsers = ({ persona }) => {
    const { id } = useParams();
    const [t] = useTranslation();
    const [data, setData] = useState([]);
    const [endUserData, setEndUserData] = useState([]);
    const [confirmActivateModal, setConfirmActivateModal] = useState({ open: false, record: null });
    const [paginationParams, setPaginationParams] = useState({
          limit: 10,
          offset: 0,
          sortField: "createdAt",
          sortOrder: -1
        });

    const navigate = useNavigate();

    useEffect(() => {
      fetchCategoryUsers();
    }, [paginationParams]);

    const fetchCategoryUsers = async () => {
      const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/categories/${id}`, { withCredentials: true })
      .catch((err) => {
          console.log(err);
      });

      console.log("Category Users Response:", response?.data);

      setData(response?.data);
      setEndUserData(response?.data?.end_users);
    };

  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder
    }));
  };

  const columns = [
    { field: "id", header: "ID", sortable: true, body: (rowData) => rowData.id },
    { field: "username", header: t("Username"), sortable: true, filter: true, body: (rowData) => rowData.username },
    { field: "email", header: t("Email"), sortable: true, filter: true, body: (rowData) => rowData.email },
    { field: "createdAt", header: t("Creation Date"), sortable: true, filter: true, body: (rowData) => new Date(rowData.createdAt).toLocaleString('en-GB') },
  ];

  const actions = [
    { text: 'Activate / Deactivate', color: "primary", onClick: (row) => setConfirmActivateModal({ open: true, record: row }), status:"success" }
  ];

    return (
      <div>
        <DataTableComponent
          data={endUserData}
          columns={columns}
          actions={actions}
          totalRecords={endUserData?.length}
          enableCreate={false}
          enablePagination={true}
          paginationParams={paginationParams}
          onDataTableEvent={onDataTableEvent}
          enableLazyLoading={false}
          enableExport={true}
        />
        
        {confirmActivateModal.open && (
          <ActivateDeactivateModal
            sentData={confirmActivateModal.record}
              onEvent={setConfirmActivateModal}
              onConfirm={fetchCategoryUsers}
              apiPath="endUsers"
              axios={axiosInstance}
              columnName="username"
              dbAction="active"
          />
        )}
            
      </div>
    );
};

export default CategoryUsers;